import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { codeSnippetAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import CodeSnippetViewer from '../components/CodeSnippetViewer';
import UserCodeSnippetViewer from '../components/UserCodeSnippetViewer';

const CodeSnippetView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [snippet, setSnippet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const isAdmin = user?.role === 'admin';

  useEffect(() => {
    fetchSnippet();
  }, [id]);

  const fetchSnippet = async () => {
    try {
      setLoading(true);
      const response = await codeSnippetAPI.getSnippet(id);
      setSnippet(response.data.snippet);
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load snippet');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    if (isAdmin) {
      navigate('/code-snippets');
    } else {
      navigate('/access-code');
    }
  };

  if (loading) {
    return (
      <div className="container" style={{ textAlign: 'center', padding: '40px' }}>
        <p>Loading snippet...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container" style={{ padding: '20px' }}>
        <div style={{
          padding: '12px 16px',
          backgroundColor: '#fee',
          border: '1px solid #fcc',
          borderRadius: '6px',
          color: '#c00',
          marginBottom: '20px'
        }}>
          {error}
        </div>
        <button onClick={handleBack} className="btn btn-secondary">
          ← Back to Snippets
        </button>
      </div>
    );
  }

  if (!snippet) {
    return (
      <div className="container" style={{ padding: '20px' }}>
        <p>Snippet not found</p>
        <button onClick={handleBack} className="btn btn-secondary">
          ← Back to Snippets
        </button>
      </div>
    );
  }

  return (
    <div>
      {isAdmin && (
        <div className="container" style={{ padding: '20px', maxWidth: '95%', margin: '0 auto' }}>
          <div style={{ marginBottom: '20px' }}>
            <button 
              onClick={handleBack} 
              className="btn btn-secondary"
              style={{ marginBottom: '10px' }}
            >
              ← Back to Snippets
            </button>
          </div>
          
          <CodeSnippetViewer snippet={snippet} />
        </div>
      )}
      
      {!isAdmin && <UserCodeSnippetViewer snippet={snippet} />}
    </div>
  );
};

export default CodeSnippetView;
